import { __spreadArray } from "tslib";
import { useCallback, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useIframeMessage } from './useIframeMessage';
export function useEmbeddedEditorMessage(handleMessage, options) {
    var _a = useState([]), promises = _a[0], setPromises = _a[1];
    var _b = useState([]), loggerList = _b[0], setLoggerList = _b[1];
    var logEntry = useCallback(function (message, direction) {
        setLoggerList(function (prev) { return __spreadArray([{ message: message, time: Date.now(), direction: direction, key: uuidv4() }], prev, true); });
    }, []);
    var handleInboundMessage = function (message, dispatcher) {
        logEntry(message, 'in');
        var index = promises.findIndex(function (p) { return message.payload && p.uuid === JSON.parse(message.payload).uuid; });
        if (index > -1) {
            promises[index].resolve(message);
            setPromises(function (prev) { return prev.filter(function (_, i) { return i !== index; }); });
        }
        if (handleMessage) {
            return handleMessage(message, dispatcher);
        }
    };
    var dispatch = useIframeMessage(handleInboundMessage, options)[0];
    var handleOutboundMessage = useCallback(function (message) {
        dispatch(message);
        logEntry(message, 'out');
    }, [dispatch, logEntry]);
    var setIdentity = function (type, publicKey, signature) {
        if (!publicKey)
            return;
        var uuid = uuidv4();
        handleOutboundMessage({
            type: 'set-identity',
            payload: JSON.stringify({
                action: 'set-identity',
                type: type,
                value: publicKey,
                uuid: uuid,
            }),
            signature: signature,
        });
        return Promise;
    };
    var signResponse = function (payload, signature) {
        handleOutboundMessage({
            type: 'sign-response',
            payload: payload,
            signature: signature,
        });
    };
    /** --------------------------------------------------------------------------------------------------------------- */
    /** This is part only for AgorApp IDE, will not be exposed as public ---------------------------------------------- */
    /** --------------------------------------------------------------------------------------------------------------- */
    var submitSolution = function (type, publicKey, solution) {
        var uuid = uuidv4();
        handleOutboundMessage({
            type: 'sign-request',
            payload: JSON.stringify({
                action: 'submit-solution',
                solution: solution,
                identity: {
                    type: type,
                    value: publicKey,
                },
                uuid: uuid,
            }),
        });
        return new Promise(function (resolve, reject) {
            setPromises(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ uuid: uuid, resolve: resolve, reject: reject }], false); });
        });
    };
    var signIdentity = function (type, publicKey) {
        var uuid = uuidv4();
        handleOutboundMessage({
            type: 'sign-request',
            payload: JSON.stringify({
                action: 'sign-identity',
                identity: {
                    type: type,
                    value: publicKey,
                },
                uuid: uuid,
            }),
        });
        return new Promise(function (resolve, reject) {
            setPromises(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ uuid: uuid, resolve: resolve, reject: reject }], false); });
        });
    };
    var sendReady = useCallback(function () {
        handleOutboundMessage({
            type: 'ready',
            payload: JSON.stringify({
                action: 'ready',
            }),
        });
    }, [handleOutboundMessage]);
    return {
        setIdentity: setIdentity,
        submitSolution: submitSolution,
        signResponse: signResponse,
        signIdentity: signIdentity,
        sendReady: sendReady,
        loggerList: loggerList,
    };
}
//# sourceMappingURL=useEmbeddedEditorMessage.js.map